import RegSettingForm from "./regSettingForm.container";

export default RegSettingForm;
